import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError, ErrorSource } from '../../constant/model/api/api';

interface ApiErrorState {
  errors: Record<ErrorSource, ApiError | null>;
  lastError: ApiError | null;
}

const initialState: ApiErrorState = {
  errors: Object.fromEntries(Object.values(ErrorSource).map((source) => [source, null])) as Record<
    ErrorSource,
    ApiError | null
  >,
  lastError: null,
  
};

const normalizeError = (source: ErrorSource, error: any): ApiError => {
  if ('statusCode' in error) {
    return {
      source,
      message: error.message || 'An unknown error occurred',
      statusCode: error.statusCode || 500,
      stack: error.stack || '',
      timestamp: Date.now(),
    };
  }
  return {
    source,
    message: error instanceof Error ? error.message : 'An unknown error occurred',
    statusCode: 500,
    stack: error instanceof Error ? error.stack : '',
    timestamp: Date.now(),
  };
};

const apiErrorSlice = createSlice({
  name: 'apiError',
  initialState,
  reducers: {
    setApiError: (state, action: PayloadAction<{ source: ErrorSource; error: any }>) => {
      const { source, error } = action.payload;
      const apiError = normalizeError(source, error);
      state.errors[source] = apiError;
      state.lastError = apiError;
    },

    clearApiError: (state, action: PayloadAction<ErrorSource>) => {
      const source = action.payload;
      state.errors[source] = null;

      if (state.lastError && state.lastError.source === source) {
        state.lastError = null;
      }
    },

    clearAllApiErrors: (state) => {
      Object.keys(state.errors).forEach((key) => {
        state.errors[key as ErrorSource] = null;
      });
      state.lastError = null;
    },
  },
});

export const { setApiError, clearApiError, clearAllApiErrors } = apiErrorSlice.actions;
export default apiErrorSlice.reducer;
